import type { Step } from '@/components/wizard/Step';

import type { AddPrivateLinkWizardState } from './addPrivateLinkWizardState';
import { AddPrivateLinkStep } from './steps/AddPrivateLinkStep';

export const AddPrivateLinkCreationFlow: Step<AddPrivateLinkWizardState> = {
  id: 'add_private_link',
  Component: AddPrivateLinkStep,
};
